export const API_URL =  process.env.REACT_APP_API_URL || 'https://news-letter-api.netlify.app/api' || 'http://localhost:5000/api';